import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* fetchContentCardDefaultsInCurrentBoard() {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  yield put(actions.fetchContentCardDefaults(pointSystem.id));

  let items;
  try {
    ({ items } = yield call(request, api.getContentCardDefaults, pointSystem.id));
  } catch (error) {
    yield put(actions.fetchContentCardDefaults.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.fetchContentCardDefaults.success(pointSystem.id, items));
}

export function* createContentCardDefaultInCurrentBoard(type, data = {}) {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  const createData = { type, ...data };

  yield put(actions.createContentCardDefault(pointSystem.id, createData));

  let item;
  try {
    ({ item } = yield call(request, api.createContentCardDefault, pointSystem.id, createData));
  } catch (error) {
    yield put(actions.createContentCardDefault.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.createContentCardDefault.success(item));
  yield call(fetchContentCardDefaultsInCurrentBoard);
}

export function* updateContentCardDefault(id, data) {
  yield put(actions.updateContentCardDefault(id, data));

  let item;
  try {
    ({ item } = yield call(request, api.updateContentCardDefault, id, data));
  } catch (error) {
    yield put(actions.updateContentCardDefault.failure(id, error));
    return;
  }

  yield put(actions.updateContentCardDefault.success(item));
}

export function* deleteContentCardDefault(id) {
  yield put(actions.deleteContentCardDefault(id));

  let item;
  try {
    ({ item } = yield call(request, api.deleteContentCardDefault, id));
  } catch (error) {
    yield put(actions.deleteContentCardDefault.failure(id, error));
    return;
  }

  yield put(actions.deleteContentCardDefault.success(item));
  yield call(fetchContentCardDefaultsInCurrentBoard);
}

export default {
  fetchContentCardDefaultsInCurrentBoard,
  createContentCardDefaultInCurrentBoard,
  updateContentCardDefault,
  deleteContentCardDefault,
};

